import React from "react";
import Home from "./pages/Home"; // Removed the {} brackets

const App: React.FC = () => {
  return <Home />;
};

export default App;